import { takeLatest, all, put, select } from 'redux-saga/effects';
import LostPasswordPanelActions from './actions';

import { FORM_ID } from '../index';
import { CKForm } from 'console-kit';

function* onLostPasswordRequestHandler({ payload: { formRef } }) {
  yield put(CKForm.Actions.validateForm(FORM_ID));
  const isValid = yield select(CKForm.Selectors.isFormValid, FORM_ID);

  if (isValid) {
    formRef.method = 'post';
    formRef.submit();
  } else {
    yield put(LostPasswordPanelActions.onLostPasswordPanelFailure());
  }
}

function* authFormSagas() {
  yield all([takeLatest(LostPasswordPanelActions.onLostPasswordPanelRequest.getType(), onLostPasswordRequestHandler)]);
}

export default authFormSagas;
